export class ZohoSyncRequestAddModel {
    public type: number;
    public startDate: string;
    public endDate: string;
}
